import Row from '@components/Row';
import ShopSelectorChip from '@components/shop/ShopSelectorChip';
import { Link } from '@stackflow/link';

import useSelectShop from './hooks/useSelectShop';

function ShopSelector() {
    const { displayName, isVisible } = useSelectShop();
    if (isVisible) {
        return (
            <Row fullWidth justify='center' align='center'>
                <Link activityName='StampScopeBottomSheet'
                    activityParams={{}}>
                    <ShopSelectorChip>
                        {displayName}
                    </ShopSelectorChip>
                </Link>
            </Row>
        );
    }
    return null;
}

export default ShopSelector;
